/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//
export default {
  'navigation.global-side-navigation.customize-sidebar.label': 'Customize sidebar',
  'navigation.global-side-navigation.for-you.label': 'For you',
  'navigation.global-side-navigation.more-menu.label': 'More',
  'navigation.global-side-navigation.onboarding-menu.give-feedback': 'Give feedback',
  'navigation.global-side-navigation.onboarding-menu.guided-tour': 'Take a guided tour',
  'navigation.global-side-navigation.onboarding-menu.navigation-docs': 'Read about the new navigation',
  'navigation.global-side-navigation.panel-splitter.label': 'Resize panel',
  'navigation.global-side-navigation.recents.label': 'Recent',
  'navigation.global-side-navigation.starred.label': 'Starred',
};
